import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Card, Button } from 'react-bootstrap';
import api from '../utils/api';

const CardPaymentEmail = () => {
    const { id } = useParams();
    const history = useHistory();
    const [email, setEmail] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        api.get(`/api/card_payments/${id}/email`)
            .then(res => {
                setEmail(res.data);
                setLoading(false);
            })
            .catch(err => {
                setError(err.message);
                setLoading(false);
            });
    }, [id]);

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <div className="container mt-3">
            <Button
                variant="secondary"
                size="sm"
                className="mb-2"
                onClick={() => history.goBack()}
            >
                ← Go Back
            </Button>

            <Card>
                <Card.Header>
                    <strong>Transaction:</strong> {email.transactionId}<br />
                    <strong>From:</strong> {email.emailFrom}<br />
                    <strong>Received:</strong>{' '}
                    {new Date(email.emailReceivedAt).toLocaleString()}
                </Card.Header>

                <Card.Body style={{ backgroundColor: '#fafafa' }}>
                    {email.emailHtml ? (
                        <div
                            dangerouslySetInnerHTML={{ __html: email.emailHtml }}
                        />
                    ) : (
                        <pre style={{ whiteSpace: 'pre-wrap' }}>
                            {email.emailBody}
                        </pre>
                    )}
                </Card.Body>
            </Card>
        </div>
    );
};

export default CardPaymentEmail;